import { render, staticRenderFns } from "./ProductsWide.vue?vue&type=template&id=7cbdf7e9&"
import script from "./ProductsWide.vue?vue&type=script&lang=js&"
export * from "./ProductsWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,MediumProductCard: require('/vercel/path0/components/cards/MediumProductCard.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
